import { render, staticRenderFns } from "./lightHeader.vue?vue&type=template&id=1b9677d3&scoped=true"
import script from "./lightHeader.vue?vue&type=script&lang=js"
export * from "./lightHeader.vue?vue&type=script&lang=js"
import style0 from "./lightHeader.vue?vue&type=style&index=0&id=1b9677d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9677d3",
  null
  
)

export default component.exports